/* eslint-disable import/no-anonymous-default-export */
import { authInstance, noAuthInstance } from './axios/index';
import qs from 'qs';

export default {
  // 파일 다운로드
  downloadFile: (url) => {
    const requestOptions = {
      method: 'GET',
      url: url,
      responseType: 'blob',
    };
    return authInstance(requestOptions);
  },
  // 파일 업로드
  uploadFile: (fileList, params = {}) => {
    if (fileList.length === 0) return { data: { data: [] } };
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append(
        'files',
        file?.originFileObj ? file?.originFileObj : file,
      );
    });
    params.businessType = 'HOTEL';

    const requestOptions = {
      method: 'POST',
      url: `/api/file-stream/v1/upload?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
      timeout: 1000 * 60 * 10, // 10분
    };

    return authInstance(requestOptions);
  },
  // 파일 업로드 인증 전.
  noAuthUploadFile: (fileList, params) => {
    console.log(fileList);
    console.log(params);
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append(
        'files',
        file?.originFileObj ? file?.originFileObj : file,
      );
    });
    params.businessType = 'HOTEL';

    const requestOptions = {
      method: 'POST',
      url: `/api/file-stream/v1/upload?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
      timeout: 1000 * 60 * 3, // 3분
    };

    return noAuthInstance(requestOptions);
  },
};
